import styled, {css} from "styled-components";

const SingleItemHistoryStyled = styled.div`

background: #F3F3F3;
border-radius: 16px;
padding: 16px;
display: flex;
gap: 24px;
justify-content: space-between;
flex-direction: column-reverse;

@media only screen and (min-width: ${props => props.theme.desktopSmall}) {
  flex-direction: row !important;
		}

.cardWrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.textNotes {
      font-size: 1.2rem;
      color: #3D4543;

      & > b {
        font-size: 1.2rem;
      color: #3D4543;
      }
   }
`;

export { 
	SingleItemHistoryStyled
 };
